import type { SxProps } from "@mui/system";
import type { ThemeV2 } from "../../util/types";

export const rankBoxContainer = (
  theme: ThemeV2,
  isLandScapeMode: boolean,
): SxProps => {
  const { color, spacing, shape, elevation } = theme.tokens;
  return {
    minHeight: isLandScapeMode ? "45vh" : null,
    padding: isLandScapeMode
      ? {
          md: `${spacing["5"]}px ${spacing["4"]}px`,
          xs: `${spacing["5"]}px ${spacing["3"]}px`,
        }
      : `${spacing["2"]}px ${spacing["4"]}px ${spacing["4"]}px`,
    margin: `${spacing["2"]}px ${spacing["4"]}px`,
    borderWidth: 2,
    boxShadow: elevation["3"],
    backgroundColor: color.surface.card,
    borderRadius: `${shape.radius.lg}px`,
    border: 2,
    borderColor: color.action.primary,
    flexBasis: isLandScapeMode ? { md: "55%", xs: "45%" } : null,
  };
};

export const valueStyle = (theme: ThemeV2): SxProps => ({
  color: theme.tokens.color.action.primary,
  fontSize: {
    sm: theme.tokens.typography.size.xl,
    xs: theme.tokens.typography.size.md,
  },
  display: "flex",
  alignItems: "center",
});
